import { render } from "./settings_oauth_server.vue?vue&type=template&id=5b34f51c&scoped=true"
import script from "./settings_oauth_server.vue?vue&type=script&lang=js"
export * from "./settings_oauth_server.vue?vue&type=script&lang=js"

import "./settings_oauth_server.vue?vue&type=style&index=0&id=5b34f51c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b34f51c"]])

export default __exports__